<div
  *transloco="let t"
  class="notification-container d-flex align-items-center"
  [class.compact-mode]="compactMode()"
  (click)="notificationNavigationService.navigateToTable(notificationData())"
  data-cy="navigate-to-table-action">
  <div class="notification-badge-container d-flex">
    @if (!isNotificationDataRead()) {
      <span class="cx-badge-notification-sm"></span>
    }
  </div>
  <mat-icon class="notification-icon" [svgIcon]="notificationDataType() | notificationIcon" />
  <div class="flex-grow-1 d-flex flex-column" #notificationTextContainer>
    @switch (notificationDataType()) {
      @case (notificationType.DELAYED_PROCESS) {
        @let delayedNotificationText = t(notificationDataType() | notificationInfoText, { rpId: notificationDataRPId() });
        <div
          class="notification-text"
          [class.font-s]="compactMode()"
          [class.ignore-white-space]="compactMode()"
          #notificationDelayedRowText
          [matTooltip]="notificationDelayedRowText.textContent"
          [matTooltipDisabled]="hideNotificationTooltip"
          [innerHTML]="delayedNotificationText"
          (mouseover)="onNotificationTextHover(notificationDelayedRowText)">
        </div>
      }
      @case (notificationType.ERP_ORDER_NOT_FOUND) {
        <div
          #orderNotFoundText
          class="notification-text"
          [class.font-s]="compactMode()"
          [class.ignore-white-space]="compactMode()"
          [matTooltip]="orderNotFoundText.textContent"
          [matTooltipDisabled]="hideNotificationTooltip"
          (mouseover)="onNotificationTextHover(orderNotFoundText)">
          {{ t('Automatic status change based on SAP order status: The order { orderNumber } is not found within SAP.',
          { orderNumber: notificationDataOrderNumber()}) }}
          {{ t('Please check the entered order number within the RPs') }}
        </div>
      }
      @default {
        @let defaultNotificationText = t(
          notificationDataType() | notificationInfoText,
          { customer: notificationDataCustomerName(), rpId: notificationDataRPId()}
        );
        <div
          #notificationDefaultRowText
          class="notification-text"
          [class.font-s]="compactMode()"
          [matTooltip]="notificationDefaultRowText.textContent"
          [matTooltipDisabled]="hideNotificationTooltip"
          [innerHTML]="defaultNotificationText"
          (mouseover)="onNotificationTextHover(notificationDefaultRowText)">
        </div>
      }
    }
  </div>
  <div class="notification-read-icon">
    @if (isNotificationDataRead()) {
      <cw-action-icon
        icon="check_circle"
        font="material"
        data-cy="notification-check-icon"
        [class.mr-m]="!compactMode()"
        [size]="compactMode() ? 16 : 24"
        [filled]="true"
        [matTooltip]="t('Mark as unread')"
        (click)="onNotificationReadChange(); $event.stopPropagation()"/>
    } @else {
      <cw-action-icon
        icon="check_circle"
        font="material"
        data-cy="notification-check-icon"
        [class.mr-m]="!compactMode()"
        [size]="compactMode() ? 16 : 24"
        [matTooltip]="t('Mark as read')"
        (click)="onNotificationReadChange(); $event.stopPropagation()"/>
    }
  </div>
</div>
